export const stringToBoolean = (str?: string): boolean | undefined =>
  typeof str === 'string' ? str === 'true' : undefined;
